import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import Button from "../Button";
import { useTranslation } from "react-i18next";

const Index = ({
  children,
  onClose,
  handleSubmit,
  buttonText = "Save Changes",
  isCloseIcon = true,
  isFullscreen = true,
  isBottomButton = true,
  className = "",
  bottomButtonClassName = "",
  title = "",
  titleClassName = "",
  isHeader = true,
  isHeaderShadow = false,
  isOverFlow = true,
  headerClassName = "",
  buttonContainerClassName = "",
  bottomComponent,
  isButtonDisabled = false,
  overlayClassName = "",
}) => {
  const { t } = useTranslation();
  const handleBottomButtonClick = () => {
    if (handleSubmit) handleSubmit(onClose);
  };

  return (
    <div
      className={`fixed inset-0 bg-dark/40 flex justify-center items-center z-50 max-h-screen h-full overflow-hidden ${overlayClassName}`}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`bg-background flex flex-col ${
          isFullscreen ? "w-full h-full" : "rounded-lg shadow-dialog m-4"
        } ${className}`}
      >
        {isHeader && (
          <div
            className={`sticky top-0 z-10 bg-background flex flex-row justify-between items-center w-full px-4 pt-4 pb-3 ${
              isHeaderShadow ? "border-b border-border" : ""
            } ${headerClassName}`}
          >
            {title && (
              <h2 className={`text-xl font-bold text-dark ${titleClassName}`}>
                {title}
              </h2>
            )}
            {isCloseIcon && (
              <button
                onClick={onClose}
                className="w-11 h-11 rounded-full bg-secondary flex items-center justify-center text-dark hover:bg-secondary-dark transition-colors"
                aria-label={t("Close")}
              >
                <IoCloseSharp size={20} />
              </button>
            )}
          </div>
        )}
        <div
          className={`flex flex-col justify-between flex-1 gap-4 ${
            isOverFlow ? "overflow-auto px-4 py-2" : "px-4"
          }`}
          style={{ minHeight: 0 }}
        >
          {children}
        </div>
        {!bottomComponent
          ? isBottomButton && (
              <div
                className={`sticky bottom-0 z-10 bg-background shadow-sheet px-4 pb-5 pt-3 ${buttonContainerClassName}`}
              >
                <Button
                  size="lg"
                  fullWidth
                  onClick={handleBottomButtonClick}
                  disabled={isButtonDisabled}
                  className={bottomButtonClassName}
                >
                  {buttonText}
                </Button>
              </div>
            )
          : bottomComponent}
      </div>
    </div>
  );
};

export default Index;
